"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Shortcuts_1 = __importDefault(require("./Shortcuts"));
exports.default = Shortcuts_1.default;
